module.exports = __webpack_public_path__ + "img/logo.6823e087.png";